import { getP44Env } from '@project44/ui-utils';

export const LD_CLIENT_SIDE_ID: string =
  getP44Env().LAUNCH_DARKLY_CLIENT_SIDE_ID;
